import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import HeadingArea from '../../general/HeadingArea';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { MdPrint } from "react-icons/md";
import '../../css/fees/FeeReport.css';
import Logo from '../../assets/logo.png';
import axios from 'axios'


const FeeReport = ({ setLoading }) => {
  const { state } = useLocation();
  const { student, feeStr, selectedMonth, selectedAY, selectedAYTitle, selectedSection, selectedClassId } = state;
  const [response2, setResponse2] = useState({ message: '', status: 'success' });
  // const [localFeeReport, setLocalFeeReport] = useState(feeReport);
  const [dueCollectedState, setDueCollectedState] = useState({});
  const [showReceipt, setShowReceipt] = useState(false);
  const [selectedR, setSelectedR] = useState('');
  const navigate = useNavigate();

  const [transportData, setTransportData] = useState(null);
  const [showDiscountModal, setShowDiscountModal] = useState(false);

  const [discountData, setDiscountData] = useState({
    selectedMonths: [],
    discount_name: "",
    discount_amount: "",
  });



  const [feeReport, setFeeReport] = useState([]);
  const [localFeeReport, setLocalFeeReport] = useState(feeReport);

  const fetchFeeReport = async () => {
    setLoading(true);

    const params = new URLSearchParams();
    params.append('year', selectedAY);
    params.append('std_reg', student.reg_no);

    try {
      const response = await fetch(`https://api.kcian.in/get-fee-report?${params.toString()}`);
      if (response.ok) {
        const data = await response.json();
        setFeeReport(data);
        setLocalFeeReport(data);


      } else {
        console.error('Failed to fetch');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedAY && student?.reg_no) {
      fetchFeeReport();
    }
  }, [selectedAY, student?.reg_no]);

  const monthOrder = [
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
    "January",
    "February",
    "March",
  ];



  const updateStatus = async (reportId) => {
    setLoading(true);

    try {
      const response = await fetch("https://api.kcian.in/update-fee-status", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          rId: reportId,
          status: "Success",
        }),
      });

      const res = await response.json();

      if (response.ok) {
        setResponse2({ message: "Fee Status Updated!", status: "success" });

        // 🔥 Update UI without reload
        setLocalFeeReport((prev) =>
          prev.map((report) =>
            report.id == reportId
              ? { ...report, pay_status: "Success" }
              : report
          )
        );

      } else {
        setResponse2({ message: "Something Went Wrong. Please try again.", status: "error" });
      }
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setTimeout(() => setResponse2(""), 3000);
      setLoading(false);
    }
  };


  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };


  const collectFee = async (feeS) => {

    const alreadyPaid = localFeeReport.some(
      (r) =>
        r.fee_type == feeS.structure_type &&
        r.month == selectedMonth &&
        r.year == selectedAY &&
        r.pay_status == "Success"
    );

    if (alreadyPaid) {
      setResponse2({ message: "Fee Already Collected!", status: "error" });
      setTimeout(() => setResponse2(""), 3000);
      setLoading(false);
      return;
    }


    setLoading(true);

    try {
      const feeListArr = JSON.parse(feeS.fee_list);
      let totalAmount = feeListArr.reduce((sum, item) => sum + Number(item.amount), 0);

      const due_collected =
        dueCollectedState[feeS.structure_type] ? "Yes" : "No";

      if (due_collected == "Yes") {
        totalAmount += Number(feeS.due_fine);
      }

      const discount =
        feeS.structure_type === "Tution Fee"
          ? Number(discountData.discount_amount || 0)
          : 0;

      totalAmount = totalAmount - discount;

      const payload = {
        fee_type: feeS.structure_type,
        amount: totalAmount,
        pay_mode: "Cash",
        pay_status: "Success",
        std_id: student.id,
        due_collected,
        year: selectedAY,
        month: selectedMonth,
        std_reg: student.reg_no,

        discount_name:
          feeS.structure_type === "Tution Fee"
            ? discountData.discount_name
            : null,

        discount_amount:
          feeS.structure_type === "Tution Fee"
            ? discountData.discount_amount
            : 0,

        discount_months:
          feeS.structure_type === "Tution Fee"
            ? discountData.selectedMonths
            : [],
      };

      const response = await fetch("https://api.kcian.in/submit-student-fee", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      const res = await response.json();

      if (response.ok) {
        setResponse2({ message: "Fee Collected Successfully!", status: "success" });

        setLocalFeeReport(prev => [
          ...prev,
          {
            id: res.insertId || Date.now(),
            fee_type: feeS.structure_type,
            amount: totalAmount,
            pay_mode: "Cash",
            paid_on: new Date().toISOString(),
            pay_status: "Success",
            std_id: student.id,
            due_collected,
            month: selectedMonth,
            year: selectedAY,

            discount_name:
              feeS.structure_type === "Tution Fee"
                ? discountData.discount_name
                : null,

            discount_amount:
              feeS.structure_type === "Tution Fee"
                ? discountData.discount_amount
                : 0,
          }
        ]);


        const paidDate = new Date().toISOString();

        setSelectedR({
          id: res.insertId || Date.now(),
          fee_type: feeS.structure_type,
          amount: totalAmount,
          pay_mode: "Cash",
          paid_on: paidDate,
          pay_status: "Success",
          std_id: student.id,
          due_collected,
          month: selectedMonth,
          year: selectedAY,

          discount_name:
            feeS.structure_type === "Tution Fee"
              ? discountData.discount_name
              : null,

          discount_amount:
            feeS.structure_type === "Tution Fee"
              ? Number(discountData.discount_amount || 0)
              : 0,

          groupedFees: [
            {
              fee_type: feeS.structure_type,
              amount: totalAmount,
              months:
                discountData.selectedMonths?.length > 0
                  ? discountData.selectedMonths
                  : [selectedMonth],
            },
          ],

          totalAmount: totalAmount,
        });

        setShowReceipt(true);


        setShowReceipt(true);


      } else {
        setResponse2({ message: "Something Went Wrong. Please try again.", status: "error" });
      }


    } catch (error) {
      console.error("Error collecting fee:", error);
    } finally {
      setTimeout(() => setResponse2(""), 3000);
      setLoading(false);
    }
  };




  const handleShowReceipt = (report) => {
    const sameDate = getDateOnly(report.paid_on);

    const relatedItems = localFeeReport.filter(
      (r) =>
        r.std_id === report.std_id &&
        getDateOnly(r.paid_on) === sameDate &&
        r.pay_status === "Success"
    );

    const grouped = Object.values(
      relatedItems.reduce((acc, item) => {
        if (!acc[item.fee_type]) {
          acc[item.fee_type] = {
            fee_type: item.fee_type,
            amount: Number(item.amount),
            months: [item.month],
          };
        } else {
          acc[item.fee_type].amount += Number(item.amount);
          acc[item.fee_type].months.push(item.month);
        }

        return acc;
      }, {})
    );

    const totalAmount = grouped.reduce(
      (sum, g) => sum + Number(g.amount),
      0
    );

    setSelectedR({
      ...report,
      groupedFees: grouped,
      totalAmount,
    });

    setShowReceipt(true);
  };

  const numberToWords = (num) => {
    const a = [
      '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
      'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
      'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const b = [
      '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy',
      'Eighty', 'Ninety'
    ];

    const inWords = (n) => {
      if (n < 20) return a[n];
      if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
      if (n < 1000) return a[Math.floor(n / 100)] + ' Hundred ' + (n % 100 ? inWords(n % 100) : '');
      if (n < 100000) return inWords(Math.floor(n / 1000)) + ' Thousand ' + (n % 1000 ? inWords(n % 1000) : '');
      if (n < 10000000) return inWords(Math.floor(n / 100000)) + ' Lakh ' + (n % 100000 ? inWords(n % 100000) : '');
      return inWords(Math.floor(n / 10000000)) + ' Crore ' + (n % 10000000 ? inWords(n % 10000000) : '');
    };

    return inWords(num).trim() + " Only";
  };


  useEffect(() => {
    const fetchTransportDetails = async () => {
      if (!student?.transport_id) return;

      try {
        const response = await axios.get(
          "https://api.kcian.in/get-transport-mystudent",
          {
            params: {
              ay: selectedAY,
              class_name: student.class_name,
              section: selectedSection,
              reg_no: student.reg_no,
            },
          }
        );


        if (response.data.length > 0) {
          setTransportData(response.data[0]);
        }


      } catch (error) {
        console.error("Error fetching transport details:", error);
      }
    };

    fetchTransportDetails();
  }, [student, selectedAY, selectedSection]);





  const collectTransportFee = async () => {
    try {
      setLoading(true);

      const monthsToCheck =
        discountData.selectedMonths?.length > 0
          ? discountData.selectedMonths
          : [selectedMonth];

      const alreadyPaid = localFeeReport.some(
        (r) =>
          r.fee_type === "Transport Fee" &&
          r.year == selectedAY &&
          monthsToCheck.includes(r.month) &&
          r.pay_status === "Success"
      );

      if (alreadyPaid) {
        setResponse2({
          message: "Transport Fee Already Collected!",
          status: "error",
        });

        setTimeout(() => {
          setResponse2("");
        }, 3000);

        setLoading(false);
        return;
      }

      const discount = Number(discountData.discount_amount || 0);

      const finalTransportAmount = Math.max(
        0,
        Number(transportData.route_fare) - discount
      );


      const payload = {
        fee_type: "Transport Fee",
        amount: finalTransportAmount,
        pay_mode: "Cash",
        pay_status: "Success",
        std_id: student.id,
        due_collected: "No",
        year: selectedAY,

        month: selectedMonth,
        std_reg: student?.reg_no,

        discount_months:
          discountData.selectedMonths?.length > 0
            ? discountData.selectedMonths
            : [selectedMonth],

        discount_name: discountData.discount_name || null,
        discount_amount: Number(discountData.discount_amount || 0),
      };


      const response = await axios.post(
        "https://api.kcian.in/submit-student-fee",
        payload
      );

      if (response.status === 201) {
        const paidDate = new Date().toISOString();

        setResponse2({
          message: "Transport Fee Collected Successfully!",
          status: "success",
        });

        setLocalFeeReport((prev) => [
          ...prev,
          ...(payload.discount_months || []).map((month) => ({
            id: response.data?.insertId || Date.now(),
            fee_type: "Transport Fee",
            amount: finalTransportAmount,
            pay_mode: "Cash",
            pay_status: "Success",
            std_id: student.id,
            due_collected: "No",
            year: selectedAY,
            month,
            paid_on: paidDate,

            discount_name: payload.discount_name,
            discount_amount: payload.discount_amount,
          })),
        ]);

        // OPEN RECEIPT
        setSelectedR({
          id: response.data?.insertId || Date.now(),
          fee_type: "Transport Fee",
          amount: finalTransportAmount,
          pay_mode: "Cash",
          paid_on: paidDate,
          pay_status: "Success",
          std_id: student.id,
          due_collected: "No",
          year: selectedAY,
          month: selectedMonth,


          discount_name: payload.discount_name,
          discount_amount: payload.discount_amount,

          groupedFees: [
            {
              fee_type: "Transport Fee",
              amount: finalTransportAmount,
              months: payload.discount_months,
            },
          ],

          totalAmount: finalTransportAmount,
        });

        setShowReceipt(true);

        setTimeout(() => {
          setResponse2("");
        }, 3000);
      }
    } catch (error) {
      console.error(error);

      setResponse2({
        message:
          error.response?.data?.message ||
          "Failed to collect transport fee",
        status: "error",
      });

      setTimeout(() => {
        setResponse2("");
      }, 3000);
    } finally {
      setLoading(false);
    }
  };



  const transportPaidReport = localFeeReport.find(
    (r) =>
      r.fee_type === "Transport Fee" &&
      r.year == selectedAY &&
      r.month == selectedMonth
  );

  const handleMonthChange = (month) => {
    setDiscountData((prev) => ({
      ...prev,
      selectedMonths: prev.selectedMonths.includes(month)
        ? prev.selectedMonths.filter((m) => m !== month)
        : [...prev.selectedMonths, month],
    }));
  };


  const getOrderedMonths = (startMonth) => {
    const startIndex = monthOrder.indexOf(startMonth);

    if (startIndex === -1) return monthOrder;

    return [
      ...monthOrder.slice(startIndex),
      ...monthOrder.slice(0, startIndex),
    ];
  };

  const getDateOnly = (date) => {
    return new Date(date).toISOString().split("T")[0];
  };

  const groupedReports = Object.values(
    localFeeReport.reduce((acc, item) => {
      const key = `${item.std_id}-${getDateOnly(item.paid_on)}`;

      if (!acc[key]) {
        acc[key] = {
          ...item,
          months: [item.month],
        };
      } else {
        acc[key].months.push(item.month);


        if (
          item.fee_type === "Tution Fee" &&
          acc[key].fee_type !== "Tution Fee"
        ) {
          acc[key] = {
            ...item,
            months: [...acc[key].months, item.month],
          };
        }
      }

      return acc;
    }, {})
  );

  return (
    <>
      <section className='py-4'>
        <div className='px-4'>
          <HeadingArea message1='Fees' message2='Fee Report' />

          {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

          {!showReceipt &&
            <div className='profile-card'>


              <div className='d-flex justify-content-between'>
                <p className='profile-heading my-0'>Manage Fees- {state.selectedMonth}  {state.selectedAYTitle}</p>
                <button onClick={() => navigate('/admin/collect-fees')} type='button' className='profile-btn2'>
                  Go Back
                </button>
              </div>

              <p className='para-text'>Student- {state.student.name}<br />Admission No- {state.student.admission_no}<br />
                Class: {state.student.class_name} ({state.student.section})<br />Mobile No: {state.student.mobile}</p>

              <div className='table-responsive mt-4'>
                <table className='w-100 text-center'>
                  <thead className='account-thead'>
                    <tr>
                      <th className='border' colSpan={3}>Fee List</th>

                      <th className='border'>Collect Dues After</th>
                      <th className='border'>Due Fine</th>

                      <th className='border'>Structure Type</th>
                      <th className='border'>Pay In Month</th>
                      <th className='border'>Pay Info</th>

                      <th className='border'>Activity</th>
                    </tr>

                    <tr className='border-top'>
                      <th className='border'>Fee Name</th>
                      <th className='border'>Fee Type</th>
                      <th className='border'>Amount (₹)</th>
                      {/* <th></th> */}
                      <th className='border'>(Days)</th>
                      <th className='border'>(₹)</th>
                      <th className='border'>(A Y)</th>

                      <th className='border'></th>
                      <th className='border'>(Details)</th>


                      <th ></th>
                    </tr>
                  </thead>

                  <tbody>
                    {feeStr.length > 0 ? (
                      feeStr.map((feeS, index) => {
                        const feeListArr = JSON.parse(feeS.fee_list);

                        let matchedReport = null;
                        let matchedAnnualReport = null;
                        let matchedOtherReport = null;


                        if (feeS.structure_type == "Admission Fee") {
                          matchedReport = localFeeReport.length > 0 ? localFeeReport[0] : null;
                        } else {
                          matchedReport = localFeeReport.find(r => r.fee_type == feeS.structure_type &&
                            r.month == selectedMonth &&
                            r.year == selectedAY
                          );
                        }

                        if (feeS.structure_type == "Annual Fee") {
                          matchedAnnualReport = localFeeReport.length > 0 ? localFeeReport[0] : null;
                        } else {
                          matchedAnnualReport = localFeeReport.find(r => r.fee_type == feeS.structure_type &&
                            r.month == selectedMonth &&
                            r.year == selectedAY
                          );
                        }

                        if (feeS.structure_type == "Other Fee") {
                          matchedOtherReport = localFeeReport.length > 0 ? localFeeReport[0] : null;
                        } else {
                          matchedOtherReport = localFeeReport.find(r => r.fee_type == feeS.structure_type &&
                            r.month == selectedMonth &&
                            r.year == selectedAY
                          );
                        }


                        return (
                          <tr className='account-tr'>
                            <td className='border'>
                              {feeListArr.map((fee, index) => (
                                <div>
                                  <span>{fee.feePartName}</span>

                                </div>))}
                            </td>
                            <td className='border'>
                              {feeListArr.map((fee, index) => (
                                <div>

                                  <span>{fee.feePartType}</span>

                                </div>))}
                            </td>
                            <td className='border'>
                              {feeListArr.map((fee, index) => (
                                <div>

                                  <span>₹ {fee.amount}</span>
                                </div>))}
                            </td>
                            <td className='border'>{feeS.due_days}</td>
                            <td className='border'>₹ {feeS.due_fine}</td>

                            <td className='border'>{feeS.structure_type}</td>


                            <td className="border">
                              {feeS.structure_type === "Tution Fee" &&
                                !matchedReport && (
                                  <button
                                    type="button"
                                    className="profile-btn2"
                                    onClick={() => setShowDiscountModal(true)}
                                  >
                                    Add Month
                                  </button>
                                )}
                            </td>


                            <td className='border'>
                              {matchedReport ? (
                                <div className='small'>
                                  <div>
                                    <strong>Paid On:</strong> {formatDateTime(matchedReport.paid_on)}
                                  </div>

                                  {feeS?.structure_type === "Tution Fee" ? (
                                    <div>
                                      ₹
                                      {Number(matchedReport.amount) + Number(matchedReport.discount_amount || 0)}
                                      {" - "}
                                      <span className="text-danger">
                                        ₹{matchedReport.discount_amount || 0}
                                      </span>
                                      {" = "}
                                      ₹{matchedReport.amount}
                                    </div>
                                  ) : (
                                    <div>
                                      <strong>Amount:</strong> ₹{matchedReport.amount}
                                    </div>
                                  )}

                                  <div>
                                    <strong>Mode:</strong> {matchedReport.pay_mode}
                                  </div>

                                  <div>
                                    <strong>Status:</strong> {matchedReport.pay_status}
                                  </div>
                                </div>
                              ) : matchedAnnualReport ? (
                                <div className='small'>
                                  <div>
                                    <strong>Paid On:</strong> {formatDateTime(matchedAnnualReport.paid_on)}
                                  </div>

                                  {feeS?.structure_type === "Tution Fee" ? (
                                    <div>
                                      ₹
                                      {Number(matchedAnnualReport.amount) + Number(matchedAnnualReport.discount_amount || 0)}
                                      {" - "}
                                      <span className="text-danger">
                                        ₹{matchedAnnualReport.discount_amount || 0}
                                      </span>
                                      {" = "}
                                      ₹{matchedAnnualReport.amount}
                                    </div>
                                  ) : (
                                    <div>
                                      <strong>Amount:</strong> ₹{matchedAnnualReport.amount}
                                    </div>
                                  )}

                                  <div>
                                    <strong>Mode:</strong> {matchedAnnualReport.pay_mode}
                                  </div>

                                  <div>
                                    <strong>Status:</strong> {matchedAnnualReport.pay_status}
                                  </div>
                                </div>
                              ) : matchedOtherReport ? (
                                <div className='small'>
                                  <div>
                                    <strong>Paid On:</strong> {formatDateTime(matchedOtherReport.paid_on)}
                                  </div>

                                  {feeS?.structure_type === "Tution Fee" ? (
                                    <div>

                                      ₹
                                      {Number(matchedOtherReport.amount) + Number(matchedOtherReport.discount_amount || 0)}
                                      {" - "}
                                      <span className="text-danger">
                                        ₹{matchedOtherReport.discount_amount || 0}
                                      </span>
                                      {" = "}
                                      ₹{matchedOtherReport.amount}
                                    </div>
                                  ) : (
                                    <div>
                                      <strong>Amount:</strong> ₹{matchedOtherReport.amount}
                                    </div>
                                  )}

                                  <div>
                                    <strong>Mode:</strong> {matchedOtherReport.pay_mode}
                                  </div>

                                  <div>
                                    <strong>Status:</strong> {matchedOtherReport.pay_status}
                                  </div>
                                </div>
                              ) : (
                                <span className='text-danger fw-semibold'>Not Paid</span>
                              )}
                            </td>

                            <td className='border'>
                              {matchedReport ? (
                                matchedReport.pay_status == "Pending" ? (
                                  <span
                                    className="profile-btn2 cursor-pointer"
                                    onClick={() => updateStatus(matchedReport.id)}
                                  >
                                    Update Status
                                  </span>
                                ) : (
                                  <span className="profile-btn2 border-success text-success">
                                    Fee Paid
                                  </span>
                                )
                              ) : (
                                <div className='d-flex flex-column align-items-center'>

                                  {/* DUE COLLECTED CHECKBOX */}
                                  <label className='para-text my-2'>
                                    <input
                                      type="checkbox"
                                      className='pt-2'
                                      checked={!!dueCollectedState[feeS.structure_type]}
                                      onChange={(e) =>
                                        setDueCollectedState(prev => ({
                                          ...prev,
                                          [feeS.structure_type]: e.target.checked
                                        }))
                                      }
                                    />
                                    &nbsp;Due Collected
                                  </label>

                                  {/* COLLECT BUTTON */}
                                  <span
                                    className="profile-btn2 cursor-pointer"
                                    onClick={() => collectFee(feeS)}
                                  >
                                    Collect Fee
                                  </span>
                                </div>
                              )}
                            </td>

                          </tr>
                        )
                      })) :
                      (
                        <tr className='account-tr'>
                          <td className='py-3' colSpan={11}>
                            No Fee Structure Created yet.
                          </td>
                        </tr>
                      )}

                    {student?.transport_id && transportData && (
                      <tr className="account-tr">
                        <td className="border">
                          <span>Transport Fee <br />Route: ( {transportData.route_title})</span>
                        </td>

                        <td className="border">-</td>

                        <td className="border">
                          ₹ {transportData.route_fare}
                        </td>



                        <td className="border">-</td>

                        <td className="border">-</td>


                        <td className="border">
                          Transport Fee
                        </td>

                        <td className="border">
                          {!transportPaidReport && (
                            <button
                              type="button"
                              className="profile-btn2"
                              onClick={() => setShowDiscountModal(true)}
                            >
                              Add Month
                            </button>
                          )}
                        </td>

                        {/* PAY INFO */}
                        <td className="border">
                          {transportPaidReport ? (
                            <div className="small">
                              <div>
                                <strong>Paid On:</strong>{" "}
                                {formatDateTime(transportPaidReport.paid_on)}
                              </div>

                              <div>
                                ₹
                                {Number(transportPaidReport.amount) + Number(transportPaidReport.discount_amount || 0)}
                                {" - "}
                                <span className="text-danger">
                                  ₹{transportPaidReport.discount_amount || 0}
                                </span>
                                {" = "}
                                ₹{transportPaidReport.amount}
                              </div>

                              <div>
                                <strong>Mode:</strong> {transportPaidReport.pay_mode}
                              </div>

                              <div>
                                <strong>Status:</strong> {transportPaidReport.pay_status}
                              </div>
                            </div>
                          ) : (
                            <span className="text-danger fw-semibold">
                              Not Paid
                            </span>
                          )}
                        </td>

                        {/* ACTION */}
                        <td className="border">
                          {transportPaidReport?.pay_status === "Pending" ? (
                            <span
                              className="profile-btn2 cursor-pointer"
                              onClick={() => updateStatus(transportPaidReport.id)}
                            >
                              Update Status
                            </span>
                          ) : transportPaidReport?.pay_status === "Success" ? (
                            <span className="profile-btn2 border-success text-success ">
                              Fee Paid
                            </span>
                          ) : (
                            <span
                              className="profile-btn2 cursor-pointer p-1"
                              onClick={collectTransportFee}
                            >
                              Collect Fee
                            </span>
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>

                </table>
              </div>


              <p className='profile-heading mt-4'>Payment History</p>

              {/* PAYMENT HISTORY TABLE */}
              <div className='table-responsive mt-4'>
                <table className='w-100 text-center'>
                  <thead className='account-thead rounded-top'>
                    <tr>
                      <th className='border'>Receipt No</th>
                      <th className='border'>Fee Type</th>
                      <th className='border'>Amount (₹)</th>
                      <th className='border'>Pay Mode</th>
                      <th className='border'>Paid On</th>
                      <th className='border'>Status</th>
                      <th className='border'>Due Collected</th>
                      <th className='border'>Activity</th>
                    </tr>
                  </thead>

                  <tbody>
                    {groupedReports.length > 0 ? (
                      groupedReports.map((report, index) => (
                        <tr key={index} className='account-tr'>
                          <td className='border'>{report.id}</td>
                          <td className='border'>{report.fee_type}</td>
                          <td className='border'>₹ {report.amount}</td>
                          <td className='border text-capitalize'>{report.pay_mode}</td>
                          <td className='border'>{formatDateTime(report.paid_on)}</td>
                          <td className='border'>
                            {report.pay_status === "Success" ? (
                              <span className='text-success fw-semibold'>Paid</span>
                            ) : (
                              <span className='text-warning fw-semibold'>Pending</span>
                            )}
                          </td>
                          <td className='border text-capitalize'>{report.due_collected || "No"}</td>
                          <th className='border'><MdPrint className='account-icon1' title='Print Receipt' onClick={() => handleShowReceipt(report)} /></th>
                        </tr>
                      ))
                    ) : (

                      <tr className='account-tr'>
                        <td colSpan={6} className="py-3">
                          No Payment History Available.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>



            </div>
          }



          {showReceipt && (() => {
            return (
              <div className="profile-card">

                <div className="d-flex justify-content-between">
                  <p className="profile-heading my-0">
                    Fee Receipt - {selectedR.month} {selectedR.year}
                  </p>

                  <button
                    onClick={() => setShowReceipt(false)}
                    type="button"
                    className="profile-btn2"
                  >
                    Go Back
                  </button>
                </div>

                <div
                  className="text-center border col-lg-6 col-md-7 col-12 mx-auto my-3"
                  id="receipt-area"
                >

                  <div className='receipt-logo-area'>
                    <img src={Logo} alt='Watermark' className='receipt-logo' />
                  </div>

                  <p className="mt-3 mb-0 profile-heading fs-5 fw-bold">
                    K. C. Public School
                  </p>

                  <p>
                    (C.B.S.E. Affiliation No. 1530116)
                    <br />Tata Benz Square, Berhampur
                  </p>

                  <p className="fw-bold fs-5">FEE RECEIPT</p>

                  <div className="d-flex justify-content-between fw-semibold border p-2">
                    <span>Receipt No. {selectedR.id}</span>
                    <span>Date: {formatDateTime(selectedR.paid_on)}</span>
                  </div>

                  <div className="border p-2 text-start fw-semibold">
                    <span>
                      Admission No. {state.student.admission_no}
                      <br />
                      Student Name: {state.student.name}
                    </span>
                  </div>

                  <div className="d-flex justify-content-between fw-semibold border p-2">
                    <span>Class: {state.student.class_name}</span>
                    <span>Section: {state.student.section}</span>
                  </div>

                  {/* TABLE */}
                  <div className="table-responsive">
                    <table className="w-100 table border text-start">

                      <thead>
                        <tr>
                          <th className="p-2">Fee Details</th>
                          <th className="p-2">Amount</th>
                        </tr>
                      </thead>

                      <tbody>
                        {selectedR?.groupedFees?.map((fee, index) => (
                          <tr key={index}>
                            <td className="p-2">
                              {fee.fee_type}
                              <div className="text-muted small">
                                Months: ({fee.months.join(", ")})
                              </div>
                            </td>

                            <td className="p-2">
                              ₹ {fee.amount}
                            </td>
                          </tr>
                        ))}
                      </tbody>

                      {/* TOTAL */}
                      <tr className="bg-light fw-semibold">
                        <td className="p-2">Total Fee</td>
                        <td className="p-2">
                          ₹ {selectedR?.totalAmount}
                        </td>
                      </tr>

                    </table>

                    <div className='text-start fw-semibold'>
                      <p className='px-2 para-text'>
                        Rupees {numberToWords(selectedR?.totalAmount || 0)}
                      </p>
                    </div>

                  </div>
                </div>

                {/* PRINT */}
                <div className='text-center'>
                  <button
                    className='profile-btn'
                    onClick={() => window.print()}
                  >
                    Print Receipt
                  </button>
                </div>

              </div>
            );
          })()}

          {showDiscountModal && (
            <section
              className="ins-dialog"
              onClick={() => setShowDiscountModal(false)}
            >
              <div
                className="ins-dialog-inner col-lg-8 col-12 animate__animated animate__fadeInDown mx-auto"
                onClick={(e) => e.stopPropagation()}
              >

                <div className="d-flex justify-content-between">
                  <p className="profile-heading my-0">
                    Payment Details
                  </p>

                  <button className='profile-btn2' onClick={() => setShowDiscountModal(false)}>Go Back</button>

                </div>

                <div className="row mt-3">

                  <div className='mb-4 col-md-4'>
                    <div className="profile-input-area ">

                      <label className='profile-badge'>
                        Select Month*
                      </label>
                      <select
                        multiple
                        className="profile-input"
                        value={discountData.selectedMonths}
                        onChange={(e) => {
                          const selected = Array.from(
                            e.target.selectedOptions,
                            (opt) => opt.value
                          );

                          setDiscountData((prev) => ({
                            ...prev,
                            selectedMonths: selected,
                          }));
                        }}
                      >
                        {getOrderedMonths(selectedMonth).map((m) => (
                          <option key={m} value={m}>
                            {m}
                          </option>
                        ))}
                      </select>

                    </div>
                  </div>




                  <div className='mb-4 col-md-4'>
                    <div className='profile-input-area'>
                      <label className='profile-badge'>Discount Name*</label>
                      <input type='text' name='discount_name' placeholder="Enter discount name"
                        value={discountData.discount_name}
                        onChange={(e) =>
                          setDiscountData({
                            ...discountData,
                            discount_name: e.target.value,
                          })
                        }
                        className='profile-input' required />
                    </div>
                  </div>

                  <div className='mb-4 col-md-4'>
                    <div className='profile-input-area'>
                      <label className='profile-badge'>Discount Amount*</label>
                      <input type='text' name='discount_amount' placeholder="Enter amount"
                        value={discountData.discount_amount}
                        onChange={(e) =>
                          setDiscountData({
                            ...discountData,
                            discount_amount: e.target.value,
                          })
                        } className='profile-input' required />
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-end gap-2">

                  <button
                    className='profile-btn'
                    onClick={() => {

                      setShowDiscountModal(false);
                    }}
                  >
                    Save Discount
                  </button>
                </div>
              </div>
            </section>
          )}
        </div>
      </section>
    </>
  )
}

export default FeeReport